module.exports = __webpack_public_path__ + "img/icon_5.da50a8b9.png";